import "vant/es/count-down/style";
import _CountDown from "vant/es/count-down";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import Geo from 'drip/geo';
import Vue from 'vue';
import { dateFormat, parseDetailUrl } from '@/utils/';
import WishCard from './CityCard.vue';
Vue.use(_CountDown);
export default {
  components: {
    WishCard: WishCard
  },
  props: {
    tourProjectList: {
      type: Array,
      value: []
    },
    inPreProjectList: {
      type: Array,
      value: []
    },
    tour: {
      type: Object,
      value: {}
    },
    celebrityId: {
      type: Number,
      value: null
    }
  },
  mounted: function mounted() {
    this.reportMv();
  },
  computed: {
    hasWishedIds: function hasWishedIds() {
      return this.inPreProjectList.filter(function (el) {
        return el.hasWished;
      }).map(function (el) {
        return el.cityId;
      });
    }
  },
  methods: {
    dateFormat: dateFormat,
    to: function to(item, index) {
      try {
        var _item$jumpdetailurl = item.jumpdetailurl,
          jumpdetailurl = _item$jumpdetailurl === void 0 ? '' : _item$jumpdetailurl,
          performanceId = item.performanceId;
        this.reportMc(item, index, 'b_movie_4u7mz0to_mc');
        if (jumpdetailurl) {
          this.goWithWx({
            h5Url: parseDetailUrl(jumpdetailurl),
            wxPath: "/pages/show/detail/index?id=".concat(performanceId),
            douyinPath: jumpdetailurl
          });
        } else {
          this.goWithWx({
            h5Url: "/detail/".concat(performanceId),
            wxPath: "/pages/show/detail/index?id=".concat(performanceId),
            douyinPath: "/pages/show/detail/index?id=".concat(performanceId)
          });
        }
      } catch (e) {
        this.$owlReportError('艺人主页-巡演跳转失败', e);
      }
    },
    bidParams: function bidParams(project, index) {
      var bid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'b_movie_4u7mz0to_mc';
      var cityId = Drip.constant.cityId;
      var gcityId = (Geo.getLocCitySync() || {}).cityId || cityId;
      var params = {
        evt: 'click',
        bid: bid,
        celebrity_id: this.celebrityId,
        performance_id: (project || {}).performanceId || '',
        performance_state: (project || {}).ticketStatus || '',
        city_id: cityId,
        gcity_id: gcityId,
        tour_id: this.tour.tourId,
        position: index,
        needTag: true
      };
      return params;
    },
    timeEnd: function timeEnd(index) {
      this.$emit('countdown-end', index);
    },
    getShowTime: function getShowTime(data) {
      if (!data) {
        return {
          start: '',
          end: ''
        };
      }
      if (data.length < 15) {
        return {
          start: data,
          end: ''
        };
      }
      if (data.includes('/')) {
        var list = data.split('/');
        return {
          start: "".concat(list[0], "/"),
          end: list[list.length - 1]
        };
      }
      if (data.includes('-')) {
        var _list = data.split('-');
        return {
          start: "".concat(_list[0], "-"),
          end: _list[_list.length - 1]
        };
      }
      return {
        start: data,
        end: ''
      };
    },
    lessfourBtn: function lessfourBtn(type) {
      if (type === '缺货登记') {
        return 'mark-btn';
      } else if (['部分延期', '全部延期', '售罄', '部分取消', '全部取消'].includes(type)) {
        return 'unusual-btn';
      } else {
        return 'operation-btn';
      }
    },
    passfourBtn: function passfourBtn(type) {
      if (type === '缺货登记') {
        return {
          color: '#4E759E'
        };
      } else if (['部分延期', '全部延期', '售罄', '部分取消', '全部取消'].includes(type)) {
        return {
          color: '#999999'
        };
      }
    },
    reportMv: function reportMv() {
      var _this = this;
      this.tourProjectList.forEach(function (el, index) {
        var param = _this.getMvParams('b_movie_4u7mz0to_mv', el, index);
        window.seedAction(param);
      });
    },
    reportMc: function reportMc(item, index) {
      var bid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var param = this.bidParams(item, index, bid);
      window.seedAction(param);
    },
    getMvParams: function getMvParams(bid, item, index) {
      var _item$performanceId = item.performanceId,
        performanceId = _item$performanceId === void 0 ? '' : _item$performanceId;
      var params = {
        evt: 'view',
        bid: bid,
        custom: {
          custom: {
            celebrity_id: this.celebrityId,
            performance_id: performanceId,
            tour_id: this.tour.tourId,
            position: index
          }
        }
      };
      return params;
    },
    toAddCity: function toAddCity() {
      // type:1加场，2想看
      this.reportMc({}, this.tourProjectList.length, 'b_movie_5aktz8sz_mc');
      this.$emit('onAddCity', {
        type: 1
      });
    },
    onWishChange: function onWishChange(data) {
      this.$emit('onWishChange', data);
    }
  }
};